import React, { useContext, useEffect, useState } from "react";
import { CcRootContext } from "../conversionCenterRoot";
import * as Types from "../elements/contact";
import { capitalizeFirstLetter, getArrayLastItem } from "../helpers/helpers";

const ContactScreen = ({ defaultScreen }) => {
  const ctx = useContext(CcRootContext);
  const current = defaultScreen || getArrayLastItem(ctx.history);
  const contactOption = current.activeElementPosition;
  const [contactScreenData, setContactScreenData] = useState(null);
  
  useEffect(() => {
    setContactScreenData(
      ctx.sites
        .find((site) => site.specialtyName === current.activeSpecialty).elements
        .find((element) => element.id === current.viewId)?.items[contactOption]
    );
  }, [contactOption, ctx.sites, current.activeSpecialty, current.viewId]);

  const CurrentType = contactScreenData && Types[capitalizeFirstLetter(contactOption)];

  return(
    contactScreenData ? <CurrentType data={contactScreenData} defaultScreen={defaultScreen}/> : null
  );
};

export default ContactScreen;
